let pagePromise;

export function loadEngineeringPage() {
  if (!pagePromise) {
    pagePromise = import('../pages/ProductEngineering').catch(error => {
      pagePromise = undefined;
      throw error;
    });
  }
  return pagePromise;
}

export function preloadEngineeringPage() {
  // A failed speculative request must not interrupt the current page.
  void loadEngineeringPage().catch(() => {});
}
